import ar from "../../../assets/i18n/ar.json";
import en from "../../../assets/i18n/en.json";
import fr from "../../../assets/i18n/fr.json";
import nl from "../../../assets/i18n/nl.json";
import tr from "../../../assets/i18n/tr.json";

export type SupportedLocale = "tr" | "en" | "ar" | "nl" | "fr";

export type TranslationValue =
  | string
  | string[]
  | { [key: string]: TranslationValue };

export type TranslationDictionary = Record<string, TranslationValue>;

export const SUPPORTED_LOCALES: SupportedLocale[] = [
  "tr",
  "en",
  "ar",
  "nl",
  "fr",
];

export const translations: Record<SupportedLocale, TranslationDictionary> = {
  tr: tr as TranslationDictionary,
  en: en as TranslationDictionary,
  ar: ar as TranslationDictionary,
  nl: nl as TranslationDictionary,
  fr: fr as TranslationDictionary,
};
